"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var TZ = "Europe/Paris";
  var OPERATOR_POSITION = "Opérateur";

  var stripId = function stripId(id) {
    return (id || "").replace(/^\$/, "");
  };
  var normalize = function normalize(text) {
    return (text || "").trim().replace(/\s+/g, " ").toLowerCase();
  };

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $timeout, SchedulesService, DepasService, UsersService, CustomersService) {
      _classCallCheck(this, Controller);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.SchedulesService = SchedulesService;
      this.DepasService = DepasService;
      this.UsersService = UsersService;
      this.CustomersService = CustomersService;

      this.loading = true;
      this.running = false;
      this.typedName = "";
      this.schedules = [];
      this.closures = [];
      this.appointments = [];
      this.errors = [];
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this = this;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.user = this.resolve.params.user;
                  this.userId = stripId(this.user._id);

                  // Échap après un retrait partiel : on ferme en signalant le retrait.
                  this.$scope.$on("modal.closing", function (event, reason, closing) {
                    if (!closing && _this.isRemoved()) {
                      event.preventDefault();
                      _this.close();
                    }
                  });
                  _context.prev = 3;
                  _context.next = 6;
                  return this.loadImpact();

                case 6:
                  _context.next = 12;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](3);

                  console.error(_context.t0);
                  this.loadError = "Impossible de vérifier les plages et RDV de ce conseiller.";

                case 12:
                  this.loading = false;
                  this.$timeout(function () {}, 0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 8]]);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()

      // Recense ce qui dépend du conseiller : plages, fermetures et RDV à venir.

    }, {
      key: "loadImpact",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2 = this;

          var now, results, slots, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, appointment;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  now = new Date();
                  _context2.next = 3;
                  return Promise.all([this.SchedulesService.load(null, false, null, null), this.SchedulesService.post("mobile/bookedSlots", { start: now })]);

                case 3:
                  results = _context2.sent;


                  this.schedules = (results[0] || []).filter(function (schedule) {
                    return stripId(schedule.userId) === _this2.userId;
                  });

                  slots = (results[1] || []).filter(function (depa) {
                    return depa.slot && stripId(depa.slot.operatorId) === _this2.userId && new Date(depa.slot.end) > now;
                  });

                  this.closures = slots.filter(function (depa) {
                    return depa.status === "Fermé";
                  });
                  this.appointments = slots.filter(function (depa) {
                    return ["Fermé", "Annulé", "Effectué"].indexOf(depa.status) < 0;
                  }).sort(function (a, b) {
                    return new Date(a.slot.start) - new Date(b.slot.start);
                  });

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 11;
                  _iterator = this.appointments[Symbol.iterator]();

                case 13:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context2.next = 21;
                    break;
                  }

                  appointment = _step.value;
                  _context2.next = 17;
                  return this.CustomersService.getNameById(appointment.customerId);

                case 17:
                  appointment.customerName = _context2.sent;

                case 18:
                  _iteratorNormalCompletion = true;
                  _context2.next = 13;
                  break;

                case 21:
                  _context2.next = 27;
                  break;

                case 23:
                  _context2.prev = 23;
                  _context2.t0 = _context2["catch"](11);
                  _didIteratorError = true;
                  _iteratorError = _context2.t0;

                case 27:
                  _context2.prev = 27;
                  _context2.prev = 28;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 30:
                  _context2.prev = 30;

                  if (!_didIteratorError) {
                    _context2.next = 33;
                    break;
                  }

                  throw _iteratorError;

                case 33:
                  return _context2.finish(30);

                case 34:
                  return _context2.finish(27);

                case 35:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[11, 23, 27, 35], [28,, 30, 34]]);
        }));

        function loadImpact() {
          return _ref2.apply(this, arguments);
        }

        return loadImpact;
      }()
    }, {
      key: "operatorName",
      value: function operatorName() {
        return ((this.user.firstName || "") + " " + (this.user.lastName || "")).trim();
      }
    }, {
      key: "slotLabel",
      value: function slotLabel(depa) {
        return moment(depa.slot.start).tz(TZ).format("DD/MM/YYYY HH:mm") + " - " + moment(depa.slot.end).tz(TZ).format("HH:mm");
      }
    }, {
      key: "canConfirm",
      value: function canConfirm() {
        return !this.loading && !this.running && !this.loadError && !this.appointments.length && normalize(this.typedName) === normalize(this.operatorName());
      }

      // Retire d'abord le poste pour bloquer les nouvelles réservations, puis nettoie plages et fermetures.

    }, {
      key: "confirm",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var positions, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, schedule, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, closure;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (this.canConfirm()) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  this.running = true;
                  this.errors = [];

                  _context3.prev = 4;
                  _context3.next = 7;
                  return this.loadImpact();

                case 7:
                  _context3.next = 13;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t0 = _context3["catch"](4);

                  console.error(_context3.t0);
                  this.errors.push("Impossible de revérifier les RDV à venir.");

                case 13:
                  if (!(this.errors.length || this.appointments.length)) {
                    _context3.next = 17;
                    break;
                  }

                  this.running = false;
                  this.$timeout(function () {}, 0);
                  return _context3.abrupt("return");

                case 17:
                  positions = (this.user.positions || []).filter(function (position) {
                    return position !== OPERATOR_POSITION;
                  });

                  if (!positions.length) positions = ["Conducteur"];
                  _context3.prev = 19;
                  _context3.next = 22;
                  return this.UsersService.updateAttributesById(this.userId, { positions: positions });

                case 22:
                  _context3.next = 32;
                  break;

                case 24:
                  _context3.prev = 24;
                  _context3.t1 = _context3["catch"](19);

                  console.error(_context3.t1);
                  Notiflix.Notify.failure("Le retrait du conseiller a échoué");
                  this.errors.push("Le conseiller n'a pas pu être retiré : rien n'a été modifié.");
                  this.running = false;
                  this.$timeout(function () {}, 0);
                  return _context3.abrupt("return");

                case 32:
                  this.user.positions = positions;

                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context3.prev = 36;
                  _iterator2 = this.schedules[Symbol.iterator]();

                case 38:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context3.next = 52;
                    break;
                  }

                  schedule = _step2.value;
                  _context3.prev = 40;
                  _context3.next = 43;
                  return this.SchedulesService.deleteById(schedule._id);

                case 43:
                  _context3.next = 49;
                  break;

                case 45:
                  _context3.prev = 45;
                  _context3.t2 = _context3["catch"](40);

                  console.error(_context3.t2);
                  this.errors.push("Plage " + schedule.startTime + " - " + schedule.endTime + " non supprimée.");

                case 49:
                  _iteratorNormalCompletion2 = true;
                  _context3.next = 38;
                  break;

                case 52:
                  _context3.next = 58;
                  break;

                case 54:
                  _context3.prev = 54;
                  _context3.t3 = _context3["catch"](36);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context3.t3;

                case 58:
                  _context3.prev = 58;
                  _context3.prev = 59;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 61:
                  _context3.prev = 61;

                  if (!_didIteratorError2) {
                    _context3.next = 64;
                    break;
                  }

                  throw _iteratorError2;

                case 64:
                  return _context3.finish(61);

                case 65:
                  return _context3.finish(58);

                case 66:
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context3.prev = 69;
                  _iterator3 = this.closures[Symbol.iterator]();

                case 71:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context3.next = 85;
                    break;
                  }

                  closure = _step3.value;
                  _context3.prev = 73;
                  _context3.next = 76;
                  return this.DepasService.deleteById(closure._id);

                case 76:
                  _context3.next = 82;
                  break;

                case 78:
                  _context3.prev = 78;
                  _context3.t4 = _context3["catch"](73);

                  console.error(_context3.t4);
                  this.errors.push("Fermeture du " + this.slotLabel(closure) + " non supprimée.");

                case 82:
                  _iteratorNormalCompletion3 = true;
                  _context3.next = 71;
                  break;

                case 85:
                  _context3.next = 91;
                  break;

                case 87:
                  _context3.prev = 87;
                  _context3.t5 = _context3["catch"](69);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context3.t5;

                case 91:
                  _context3.prev = 91;
                  _context3.prev = 92;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 94:
                  _context3.prev = 94;

                  if (!_didIteratorError3) {
                    _context3.next = 97;
                    break;
                  }

                  throw _iteratorError3;

                case 97:
                  return _context3.finish(94);

                case 98:
                  return _context3.finish(91);

                case 99:

                  this.running = false;

                  if (!this.errors.length) {
                    _context3.next = 105;
                    break;
                  }

                  // Le conseiller est retiré : on garde la fenêtre ouverte pour lister ce qui reste à nettoyer.
                  this.done = true;
                  Notiflix.Notify.warning("Conseiller retiré, mais certains éléments n'ont pas pu être supprimés");
                  this.$timeout(function () {}, 0);
                  return _context3.abrupt("return");

                case 105:
                  Notiflix.Notify.success("Le conseiller a été retiré de l'équipe");
                  this.close();

                case 107:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[4, 9], [19, 24], [36, 54, 58, 66], [40, 45], [59,, 61, 65], [69, 87, 91, 99], [73, 78], [92,, 94, 98]]);
        }));

        function confirm() {
          return _ref3.apply(this, arguments);
        }

        return confirm;
      }()
    }, {
      key: "isRemoved",
      value: function isRemoved() {
        return (this.user.positions || []).indexOf(OPERATOR_POSITION) < 0;
      }
    }, {
      key: "close",
      value: function close() {
        if (this.isRemoved()) {
          this.$scope.$parent.$close({ removed: true, positions: this.user.positions });
        } else {
          this.$scope.$parent.$dismiss();
        }
      }
    }]);

    return Controller;
  }();

  angular.module("users").component("removeOperator", {
    templateUrl: "app/pages/users/removeOperator/removeOperator.html",
    bindings: { resolve: "<?" },
    controller: Controller
  });
})();